var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOrg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 3.89744V0H0V17.5385H19V3.89744H9.5ZM3.8 15.5897H1.9V13.641H3.8V15.5897ZM3.8 11.6923H1.9V9.74359H3.8V11.6923ZM3.8 7.79487H1.9V5.84615H3.8V7.79487ZM3.8 3.89744H1.9V1.94872H3.8V3.89744ZM7.6 15.5897H5.7V13.641H7.6V15.5897ZM7.6 11.6923H5.7V9.74359H7.6V11.6923ZM7.6 7.79487H5.7V5.84615H7.6V7.79487ZM7.6 3.89744H5.7V1.94872H7.6V3.89744ZM17.1 15.5897H9.5V13.641H11.4V11.6923H9.5V9.74359H11.4V7.79487H9.5V5.84615H17.1V15.5897ZM15.2 7.79487H13.3V9.74359H15.2V7.79487ZM15.2 11.6923H13.3V13.641H15.2V11.6923Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrg);
export default __webpack_public_path__ + "static/media/iconOrg.3cf15820e82f3c734114222b9fbc1c8f.svg";
export { ForwardRef as ReactComponent };